angular.module('unauthorized', [
  'ngRoute',
  'config',
  'security.service',
  'directives.serverError',
  'services.utility',
  'ui.bootstrap'
])

.config(["$stateProvider", function($stateProvider){
  $stateProvider
    .state('unauthorized', {
      url: '/unauthorized',
      views: {
        header: {
          template: require('./common/header/header.tpl.html'),
          resolve: {
            user: ["User", function (User) {
              return User.current(function (user) {
                return user
              }).$promise;
            }],
          },
          controller: 'HeaderCtrl'
        },
        main: {
          template: require('./unauthorized.tpl.html'),
          title: 'Unauthorized'
        },
        footer: {
          template: require('./common/footer/footer.tpl.html'),
          controller: 'FooterCtrl'
        }
      }
    });
}]);



// WEBPACK FOOTER //
// ./client/src/app/unauthorized.js